import React from 'react'
import PropTypes from 'prop-types'
import { InputField as NuiInputField } from '@theneatcompany/nui'
import { useFormContext, useController } from 'react-hook-form'
import { useIntl } from 'react-intl'

const ControlledInputField = ({
  disabled = false,
  name,
  indicateValid = false,
  labelProps = {},
  label: labelProp = labelProps.label,
  placeholder,
  shouldDisplayErrorMessage = true,
  helperMessage,
  ...rest
}) => {
  const { control, formState: { isSubmitting } } = useFormContext()
  const {
    field,
    fieldState: { invalid, error, isDirty },
  } = useController({ name, control })

  const { formatMessage } = useIntl()

  const errorMessage = error?.message
  const label = labelProp ?? formatMessage({ id: `label.${name}` })
  const hasErrors = !!errorMessage

  // @TODO add handleChange / handleBlur if necessary
  const getHelperMessage = () => {
    if (helperMessage) return helperMessage
    return shouldDisplayErrorMessage && errorMessage ? errorMessage : undefined
  }
  return (
    <NuiInputField
      disabled={disabled || isSubmitting}
      helperMessage={getHelperMessage()}
      intent={hasErrors ? 'danger' : (indicateValid && (!invalid && isDirty) && 'success') || undefined}
      label={label}
      labelProps={labelProps}
      name={name}
      placeholder={placeholder || label}
      {...rest}
      {...field}
    />
  )
}

ControlledInputField.propTypes = {
  disabled: PropTypes.bool,
  fieldOptions: PropTypes.shape({}),
  indicateValid: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  labelProps: PropTypes.shape({
    label: PropTypes.node,
  }),
  placeholder: PropTypes.node,
  helperMessage: PropTypes.node,
  shouldDisplayErrorMessage: PropTypes.bool,
}

export default ControlledInputField
